import { toast } from 'react-toastify';
import { all, call, fork, put, takeEvery } from 'redux-saga/effects';
import { ApiResponse } from 'api/ApiClient';
import { SuccessToastContainer } from 'components/Toast/ToastContainer';
import { routeConstants } from 'routes';
import { browserHistory } from 'routes/Router';
import { getEmployersRequest } from 'store/Employers';
import { IAction, IInvite, IInviteVerify } from 'types';
import * as API from '../../api';
import * as Actions from './actions';
import { Invites } from './types';

interface IInvitePayload {
  inviteId: string;
  onSuccess?: (inviteResponse: IInvite) => void;
}

export function* verifyInvite({ payload }: IAction<Invites, IInvitePayload>) {
  try {
    const response: ApiResponse<IInviteVerify> = yield call(API.Invites.verify, payload.inviteId);
    yield put(Actions.verifyInviteSuccess(response.body));
  } catch (error: any) {
    yield put(Actions.verifyInviteFail(error, error.statusCode >= 500));
    yield put(Actions.clearInvite());
  }
}

export function* getInvite({ payload }: IAction<Invites, IInvitePayload>) {
  try {
    const response: ApiResponse<IInvite> = yield call(API.Invites.show, payload.inviteId);
    yield put(Actions.getInviteSuccess(response.body));

    // Execute on success function
    if (payload.onSuccess) yield call(payload.onSuccess, response.body);
  } catch (error: any) {
    yield put(Actions.getInviteFail(error));
    yield call(browserHistory.replace, routeConstants.private.rootPath);
  }
}

export function* acceptInvite({ payload }: IAction<Invites, IInvitePayload>) {
  try {
    const response: ApiResponse<IInvite> = yield call(API.Invites.accept, payload.inviteId);
    yield put(Actions.acceptInviteSuccess(response.body));

    // Reload employers after successful accept of invite
    yield put(getEmployersRequest());

    // Execute on success function
    if (payload.onSuccess) yield call(payload.onSuccess, response.body);

    yield call(toast, SuccessToastContainer({ message: 'Successfully accepted invitation' }));
  } catch (error: any) {
    yield put(Actions.acceptInviteFail(error));
  }
}

export function* watchVerifyInvite() {
  yield takeEvery(Invites.VERIFY_INVITE_REQUEST, verifyInvite);
}

export function* watchGetInvite() {
  yield takeEvery(Invites.GET_INVITE_REQUEST, getInvite);
}

export function* watchAcceptInvite() {
  yield takeEvery(Invites.ACCEPT_INVITE_REQUEST, acceptInvite);
}

function* invitesSaga() {
  yield all([fork(watchVerifyInvite), fork(watchGetInvite), fork(watchAcceptInvite)]);
}

export { invitesSaga };
